import { SerializedError } from '@reduxjs/toolkit';
import { FetchBaseQueryError } from '@reduxjs/toolkit/query';
import { logout } from '../store/slices/authSlice';
import { store } from '../store/store';

/**
 * Global API error handler to handle common error scenarios
 * @param error The error from RTK Query
 * @param endpoint The API endpoint that was called
 * @returns The original error for further processing
 */
export const handleApiError = (
  error: FetchBaseQueryError | SerializedError,
  endpoint?: string
): FetchBaseQueryError | SerializedError => {
  // Handle 403 Forbidden errors
  if ('status' in error) {
    if (error.status === 403) {
      // If the error is from the users/me endpoint or any other auth-related endpoint
      if (endpoint?.includes('/users/me')) {
        console.log('Session expired or unauthorized. Redirecting to login...');
        // Dispatch logout action to clear auth state
        store.dispatch(logout());
        // Redirect to login page
        window.location.href = '/login';
      }
    }
  }

  // Return the original error for further processing
  return error;
};
